import React, { useState, useEffect, useRef } from 'react';
import Slider from 'react-slick';
import connect from 'react-redux/es/connect/connect';
import { withRouter, Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { Image, Modal } from 'react-bootstrap';
import { Helmet } from 'react-helmet';

import Button from '../../components/Button/Button';
import CatalogItem from '../catalog-item/CatalogItem';
import XText from '../../components/XText/XText';

import { SLIDER_SETTINGS, MOBILE_SLIDER_SETTINGS } from '../../constants/slider.constants';

import { parserGetProduct } from '../../services/http';
import { getCommonLDScripts, getLDProduct, getLDProductGroup } from '../../services/seo';

import { t } from '../../services/storage';

import { addToCart, removeFromCart } from '../../db/Cart';

import './product.css';

const Product = (props) => {
  const {
    match: {
      params: { id },
    },
    cart = [],
    removeFromCart: actionRemoveFromCart,
    addToCart: actionAddToCart,
    translate = [],
    history,
  } = props;

  console.log(props);

  const [lodingProduct, setLodingProduct] = useState(false);
  const [productsLoading, setProductsLoading] = useState(false);
  const [data, setData] = useState({});
  const [recommendedProducts, setRecommendedProducts] = useState([]);
  const [pageOfRecommendedProducts, setPageOfRecommendedProducts] = useState(1);
  const [selectedImage, setSelectedImage] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    setLodingProduct(true);
    console.log(id);
    parserGetProduct({ id: id }).then((resp) => {
      console.log(resp);
      setLodingProduct(false);
      setProductsLoading(true);
      setData(resp);
      /*   document.title = resp.title;
      const { category_path } = resp;
      parserGetProduct('', { category: category_path[category_path.length - 1].id }).then(
        (resp) => {
          if (resp.success) {
            setRecommendedProducts(resp.products);
          }
          setProductsLoading(false);
        },
      ); */

      setProductsLoading(false);
    });
  }, [id]);

  const extraPrice =
    parseInt((translate.find((el) => el.key === 'add_price') || {}).value) / 100 + 1;
  const prices = document.querySelector('#prices')
    ? JSON.parse(document.querySelector('#prices').value)
    : 0;

  const showPrice = (add, price) => {
    const showPrice = price && !lodingProduct;
    if (add === 0) {
      return (
        <>
          <span className='uah'>{parseFloat(price * prices.uah).toFixed(0)} грн</span>
        </>
      );
    } else if (!price) {
      return <i className='fas fa-spinner fa-spin' />;
    } else {
      return (
        <>
          <span className='uah'>
            {prices.uah && showPrice ? parseFloat(parseFloat(price) * prices.uah).toFixed(0) : ' '}{' '}
            грн
          </span>
          <span className='vertical-separator' />
          <span className='usd'>
            {prices.usd && showPrice ? parseFloat(parseFloat(price) * prices.usd).toFixed(0) : ' '}$
          </span>
        </>
      );
    }
  };

  const { title, price, availableQuantity, specifications: { Parametry = {} } = {}, images = [] } =
    data || {};

  const addToCart = () => {
    const find = cart.find((e) => String(e.id) === String(id));

    if (find) {
      actionRemoveFromCart(find);
    } else {
      actionAddToCart({
        id,
        name: title,
        image: images[0],
        count: 1,
        availableQuantity,
        price: parseFloat(parseFloat(price) * extraPrice).toFixed(0),
      });
    }
  };

  const toggleIsModalOpen = () => setIsModalOpen((prevIsOpen) => !prevIsOpen);

  const prevImage = selectedImage - 1 === 0 ? images.length - 1 : selectedImage - 1;
  const nextImage = selectedImage + 1 === images.length ? 1 : selectedImage + 1;
  const sliderRef = useRef(null);

  return (
    <section className='page-product'>
      <Helmet
        script={[
          ...getCommonLDScripts(),
          getLDProduct({
            id,
            name: title,
            image: ((images || [])[0] || {}).src,
            price: parseFloat(parseFloat(price) * prices.uah).toFixed(0),
          }),
          getLDProductGroup({
            id,
            name: title,
            image: (images[0] || {}).src,
            recommendedProducts,
          }),
        ]}
      >
        <title>{title}</title>
        <meta charSet='utf-8' />
        <meta name='author' content='Xpart' />
        <meta name='robots' content='index,follow' />
        <meta name='theme-color' content='#1a7fc8' />
        <meta name='local' property='og:local' content='uk_UA' />
        <meta name='site_name' property='og:site_name' content={window.location.hostname} />
        <meta name='robots' content='max-image-preview:large' />
        <link rel='canonical' href={`${window.location.href}`} />
        <meta name='title' property='og:title' content={title} />
        <meta name='image' property='og:image' content={(images[0] || {}).src} />
        <meta name='image:width' property='og:image:width' content={128} />
        <meta name='image:height' property='og:image:height' content={103} />
        <meta name='description' property='og:description' content={`X-Part купити ${title} ✅`} />
      </Helmet>
      <div itemScope='' itemType='http://schema.org/Product' style={{ display: 'none' }}>
        <span itemProp='brand'>Xpart</span>
        <span itemProp='name'>🏷{title}</span>
        <span itemProp='description'>{`X-Part купити ${title} ✅`}</span>
        <span itemProp='sku'>{id}</span>
        <img itemProp='image' src={(images[0] || {}).src} alt={title} width='50' height='50' />
        <span itemProp='offers' itemScope='' itemType='http://schema.org/Offer'>
          <span itemProp='priceCurrency' content='UAH'>
            UAH
          </span>
          <span itemProp='price'>{parseFloat(parseFloat(price) * prices.uah).toFixed(0)}</span>
          <span itemProp='priceCurrency' content='USD'>
            USD
          </span>
          <span itemProp='price'>{parseFloat(parseFloat(price) * prices.usd).toFixed(0)}</span>
          <time itemProp='priceValidUntil' dateTime='01-05-2024'>
            17 April
          </time>
          <span itemProp='url'>{window.location.href}</span>
          <span itemProp='itemCondition'>Б/У</span>
          <span itemProp='availability' content='http://schema.org/InStock'>
            {availableQuantity ? 'В наявності' : 'Немає в наявності'}
          </span>
        </span>
        <div>
          <div itemProp='aggregateRating' itemScope='' itemType='http://schema.org/AggregateRating'>
            <span itemProp='ratingValue'>5</span>
            <span itemProp='worstRating'>1</span>
            <span itemProp='bestRating'>5</span>
            <span itemProp='reviewCount'>7</span>
          </div>
        </div>
      </div>
      <Modal
        centered
        show={isModalOpen}
        size='lg'
        onHide={toggleIsModalOpen}
        dialogClassName='dialog-nobg'
      >
        <Modal.Header closeButton />
        <Modal.Body>
          <div
            className='modal-prev'
            onClick={() => {
              sliderRef.current.slickGoTo(prevImage);
              setSelectedImage(prevImage);
            }}
          >
            ←
          </div>
          <Image
            fluid
            onClick={toggleIsModalOpen}
            src={(images[selectedImage] || {}).src}
            width={800}
            height={800}
          />
          <div
            className='modal-next'
            onClick={() => {
              sliderRef.current.slickGoTo(nextImage);
              setSelectedImage(nextImage);
            }}
          >
            →
          </div>
        </Modal.Body>
      </Modal>
      {lodingProduct && <div className='lmask' />}
      <div className='section__content'>
        <div className='page-product__info'>
          <div className='page-product__info-left'>
            <div className='page-product__carousel'>
              <div className='page-product__carousel__main-image'>
                <img
                  src={(images[selectedImage] || {}).src}
                  width={480}
                  height={480}
                  onClick={() => toggleIsModalOpen()}
                  alt='main'
                />
                <Button.Arrow
                  left
                  disabled={selectedImage === 0}
                  onClick={() => {
                    sliderRef.current.slickGoTo(selectedImage - 2);
                    setSelectedImage((prevSelectedImage) => prevSelectedImage - 1);
                  }}
                />
                <Button.Arrow
                  disabled={selectedImage === images.length - 1}
                  onClick={() => {
                    sliderRef.current.slickGoTo(selectedImage + 1);
                    setSelectedImage((prevSelectedImage) => prevSelectedImage + 1);
                  }}
                />
              </div>
              <div className='product-images-child'>
                <Slider ref={sliderRef} {...SLIDER_SETTINGS}>
                  {images.map((image, i) => (
                    <div
                      key={`${image}-${i}`}
                      className={
                        selectedImage === i
                          ? 'product-images-image selected'
                          : 'product-images-image'
                      }
                    >
                      <div
                        style={{
                          display: 'flex',
                          width: '100%',
                          height: '100%',
                          alignItems: 'center',
                        }}
                      >
                        <Image
                          src={image.src}
                          width={480}
                          height={480}
                          fluid
                          onClick={() => {
                            sliderRef.current.slickGoTo(i);
                            setSelectedImage(i);
                          }}
                          alt={image.alt}
                          style={{ cursor: 'pointer' }}
                        />
                      </div>
                    </div>
                  ))}
                </Slider>
              </div>
            </div>
          </div>

          <div className='page-product__info-right'>
            <div className='page-product__header'>
              <div className='page-product__header-title'>{title}</div>
              <div className='page-product__header-article'>{id}</div>
            </div>

            <div className='page-product__buy-section'>
              <div className='page-product__buy-section__price'>
                <div className='page-product__buy-section__price-text'>Ціна:</div>
                <div className='page-product__buy-section__price-number'>
                  {showPrice(1, parseFloat((parseFloat(price) + 0) * extraPrice).toFixed(0))}
                </div>
              </div>
              <div className='page-product__buy-section__buttons'>
                <Button className='xpa-button--rectangle xpa-button--outlined' onClick={addToCart}>
                  В корзину
                </Button>
                <Button
                  className='xpa-button--rectangle'
                  onClick={() => {
                    addToCart();
                    history.push('/order');
                  }}
                >
                  Купити в 1 клік
                </Button>
              </div>
            </div>

            <div className='page-product__carousel--mobile'>
              <div className='page-product__carousel__main-image'>
                <img
                  src={(images[selectedImage] || {}).src}
                  onClick={toggleIsModalOpen}
                  alt='selected'
                />
                <Button.Arrow
                  left
                  disabled={selectedImage === 0}
                  onClick={() => setSelectedImage(selectedImage - 1)}
                />
                <Button.Arrow
                  disabled={selectedImage === images.length - 1}
                  onClick={() => setSelectedImage(selectedImage + 1)}
                />
              </div>
              <div className='product-images-child'>
                <Slider {...MOBILE_SLIDER_SETTINGS}>
                  {images.map((image, i) => (
                    <div
                      key={`${image}-${i}`}
                      className={
                        selectedImage === i
                          ? 'product-images-image selected'
                          : 'product-images-image'
                      }
                    >
                      <div
                        style={{
                          display: 'flex',
                          width: '100%',
                          height: '100%',
                          alignItems: 'center',
                        }}
                      >
                        <Image
                          src={image.src}
                          fluid
                          onClick={() => {
                            setSelectedImage(i);
                          }}
                          alt={image.alt}
                        />
                      </div>
                    </div>
                  ))}
                </Slider>
              </div>
            </div>

            <div className='page-product__characteristics'>
              <div className='page-product__characteristics-title'>Основні характеристики:</div>
              <div className='page-product__characteristics__list'>
                {Object.entries(Parametry).map(
                  ([key, value]) =>
                    key !== 'Рахунок-фактура' && (
                      <div className='flex-container--between' key={`${key}-${value}`}>
                        <div className='product__characteristics__list-name'>{`${key}:`}</div>
                        <div className='product__characteristics__list-value'>
                          {Array.isArray(value) ? value.join(',') : value}
                        </div>
                      </div>
                    ),
                )}
              </div>
            </div>

            <div className='page-product__delivery'>
              <div className='page-product__delivery-title'>Умови доставки:</div>
              <p className='page-product__delivery-description'>
                Доставка транспортними компаніями Відповідно до тарифів транспортного оператора.
                Доставка в Україну - <strong>2-4 дні</strong>
              </p>

              <div className='page-product__delivery-title'>Оплата</div>
              <p className='page-product__delivery-description'>
                Сплатити товар можна банківським переказом на картку Приватбанку, платіжними
                системами Visa та MasterCard (Liqpay), у точці видачі товару кур'єрської служби
                доставки у Вашому місті (Залишок від внесення передоплати)
              </p>

              <div className='page-product__delivery-title'>Гарантія</div>
              <p className='page-product__delivery-description'>
                Гарантія на придбаний товар 14 днів з моменту покупки
              </p>
            </div>
          </div>
        </div>

        {!!(recommendedProducts || []).length && (
          <div className='flex-container--bottom-70'>
            <div className='section__title'>
              <XText>Рекомендовані</XText>товари
            </div>
            <div
              className='flex-container--between flex-container--wrap flex-container--bottom-70'
              style={{ position: 'relative' }}
            >
              {productsLoading && <div className='lmask' />}
              {(recommendedProducts || [])
                .slice((pageOfRecommendedProducts - 1) * 4, pageOfRecommendedProducts * 4)
                .map((product) => (
                  <Link to={`/products/${product.id}`} key={product.id}>
                    <CatalogItem
                      {...{
                        ...product,
                        price: showPrice(
                          0,
                          parseFloat(
                            (parseFloat(product.price_with_delivery) + 0) * extraPrice,
                          ).toFixed(0),
                        ),
                      }}
                    />
                  </Link>
                ))}
            </div>
            <div className='flex-container--center'>
              <Button.Arrow
                disabled={pageOfRecommendedProducts === 1}
                left
                onClick={() => setPageOfRecommendedProducts((prevPage) => prevPage - 1)}
              />
              <Button.Arrow
                disabled={pageOfRecommendedProducts * 4 >= recommendedProducts.length}
                onClick={() => setPageOfRecommendedProducts((prevPage) => prevPage + 1)}
              />
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

function mapStateToProps(state) {
  return {
    view: state.view,
    translate: state.translate,
    cart: state.cart,
    user: state.user,
    ex: state.ex,
  };
}
function matchDispatchToProps(dispatch) {
  return bindActionCreators({ t, addToCart, removeFromCart }, dispatch);
}

export default withRouter(connect(mapStateToProps, matchDispatchToProps)(Product));
